// Code for the ButtonCustom component
import React from 'react';
import './ButtonConfirm.css';

const ButtonConfirm = ({ onClick, text, style}) => {
    return (
        <button style={style} className="button-confirm" onClick={onClick}>{text}</button>
    );
};

export default ButtonConfirm;
